/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CatalogoServicio } from './catalogoServicio';

export interface Productos { 
    secuencial?: number;
    idProducto?: string;
    idGrupo?: string;
    servicio?: string;
    producto?: string;
    nombre?: string;
    idAuxiliar?: string;
    trxConsulta?: string;
    trxPago?: string;
    trxReverso?: string;
    tituloReferencia?: string;
    tipoDatoReferencia?: string;
    longitudReferencia?: string;
    tipoPago?: string;
    consultaAuxiliar?: string;
    tipoControl?: string;
    valoresRecarga?: string;
    campos?: string;
    orden?: string;
    proveedor?: string;
    trxAux?: string;
    infoAdd?: string;
    urlImagen?: string;
    comisionRubro?: boolean;
    estaActivo?: boolean;
    estaActivoPersonalizado?: boolean;
    catalogoServicio?: CatalogoServicio;
    codigoCatalogoServicio?: number;
}